import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('marketingResourcePoolStore')
@observer
class marketingResourcePool extends Component {
  render() {
    const { marketingResourcePoolStore, location } = this.props
    const { isFetching } = marketingResourcePoolStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default marketingResourcePool;
